module.exports = __webpack_public_path__ + "assets/35fc19f5a737e6fad5575df7b5560dab.mp3";